
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/ui-components/PageTitle/PageTitle.vue';

@Component({
  name: 'ManageMyAds',
  components: {
    PageTitle
  },
})
export default class ManageMyAds extends Vue {
  
}
